import * as actions from './actions'
import * as mutations from './mutations'

export default {
  namespaced: true,
  state: {
    agreements: [],
    company: {
      id: undefined,
      attributes: {
        settings: {},
      },
    },
    customFields: [],
    errors: [],
    expandedServiceId: undefined,
    loadingAgreements: true,
    loadingServices: true,
    loadingTemplates: true,
    serviceAddOns: [],
    serviceCategories: [],
    serviceClassifications: [],
    serviceModifiers: [],
    serviceTaxes: [],
    services: [],
    showError: false,
    showSaved: false,
    templates: [],
    undeleteModal: false,
    undeletableServices: [],
    userProfile: {
      id: undefined,
      attributes: {},
    },
  },
  actions,
  mutations,
}
